<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="adjustment_list" />

    <div class="card border-0 shadow-none rounded-1 mb-25">
      <div class="card-body p-xl-40">
        <div class="row g-3 align-items-center">
          <div class="col-lg-8">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <button
                type="button"
                class="btn style-two px-4 h-55"
                data-bs-toggle="modal"
                data-bs-target="#adjustmentFilterModal"
              >
                {{ $t("adjustment_page.filter") }}
                <i class="ri-filter-line ms-1"></i>
              </button>

              <div class="search-box position-relative">
                <input
                  type="text"
                  v-model="searchQuery"
                  :placeholder="$t('adjustment_page.search_placeholder')"
                  class="form-control bg-white h-55 shadow-none pe-5"
                />
                <span class="search-icon">
                  <i class="ri-search-line"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="d-flex justify-content-lg-end">
              <router-link to="/create-adjustment" class="btn style-one d-inline-flex align-items-center h-55 px-4">
                <i class="ri-add-circle-line me-1"></i>
                {{ $t("create_adjustment") }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AdjustmentList
      :adjustments="adjustments"
      :loading="loading"
      @view-details="handleViewDetails"
      @delete-adjustment="handleDeleteAdjustment"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>

  <!-- Filter Modal -->
  <div class="modal fade" id="adjustmentFilterModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow">
        <div class="modal-header border-bottom-dashed">
          <h5 class="modal-title fw-bold">{{ $t("adjustment_page.advanced_filter") }}</h5>
          <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" :aria-label="$t('common.close')"></button>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label fs-14 text-title">{{ $t("adjustment_page.warehouse") }}</label>
              <select class="form-select bg-light border-0 fs-14 shadow-none" v-model="filters.warehouse_id">
                <option value="">{{ $t("adjustment_page.all_warehouses") }}</option>
                <option v-for="w in warehouses" :key="w.id" :value="w.id">{{ w.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer border-top-dashed justify-content-between">
          <button type="button" class="btn btn-light" @click="resetFilters">{{ $t("adjustment_page.reset") }}</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="applyFilters">{{ $t("adjustment_page.apply_filter") }}</button>
        </div>
      </div>
    </div>
  </div>

  <DetailsModal :adjustment="selectedAdjustment" :loading="detailsLoading" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import AdjustmentList from "../../components/Adjustments/AdjustmentList/AdjustmentList.vue";
import DetailsModal from "../../components/Adjustments/AdjustmentList/DetailsModal.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { useAdjustmentList } from "../../composables/useAdjustment";

export default defineComponent({
  name: "AdjustmentListPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    AdjustmentList,
    DetailsModal,
    MainFooter,
  },
  setup() {
    return useAdjustmentList();
  },
});
</script>

<style scoped>
.search-box {
  width: min(100%, 360px);
}

.search-box .form-control {
  padding-left: 18px;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
  background: #fff;
  color: #1f2940;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.search-box .form-control:focus {
  border-color: #5d5fef;
  box-shadow: 0 0 0 3px rgba(93, 95, 239, 0.12);
}

.search-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #8f9bb3;
  pointer-events: none;
  font-size: 18px;
}
</style>
